<template>
    <v-card>
        <v-card-title>
            {{ $t("Pääkäyttäjien muutosloki") }}
            <v-spacer></v-spacer>
            <v-btn icon @click="$emit('close')">
                <v-icon>{{ icons.mdiClose }}</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text>
            <v-data-table
                :headers="headers"
                :items="rows"
                :loading="loading"
                :items-per-page="pageSize"
                :server-items-length="total"
                :page.sync="page"
                :footer-props="{ 'items-per-page-options': [pageSize], showFirstLastPage: false }"
                hide-default-footer
                mobile-breakpoint="0"
                :no-data-text="$t('Ei merkintöjä')"
            >
                <template #[`item.timestamp`]="{ item }">
                    {{ formatTimestamp(item.timestamp) }}
                </template>

                <template #[`item.target`]="{ item }">
                    <span v-if="item.target_user">
                        {{ item.target_user.last_name }} {{ item.target_user.first_name }} ({{item.target_user.id}})
                    </span>
                    <span v-else class="text--disabled">—</span>
                </template>

                
                <template #[`item.action`]="{ item }">
                    <v-chip
                        small
                        :color="item.log_type === 3 ? 'success' : 'error'"
                        text-color="white"
                    >
                        {{ actionLabel(item.log_type) }}
                    </v-chip>
                </template>

   
                <template #[`item.performed_by`]="{ item }">
                    <span v-if="item.performed_by">
                        {{ item.performed_by.last_name }} {{ item.performed_by.first_name }} ({{item.performed_by.id}})
                    </span>
                    <span v-else class="text--disabled">—</span>
                </template>
            </v-data-table>

            <div class="d-flex align-center justify-end mt-2" v-if="total > pageSize">
                <v-pagination
                    v-model="page"
                    :length="pageCount"
                    :total-visible="7"
                    @input="fetchLog"
                />
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
import { ref, computed, onMounted, watch } from "@vue/composition-api";
import { mdiClose } from "@mdi/js";
import adminApi from "@/api/admin";
import { useTranslations } from "@core/libs/i18n";

const PROMOTE = 3;
const DEMOTE = 4;

export default {
    setup(_, { emit }) {
        const { t } = useTranslations();

        const rows = ref([]);
        const loading = ref(false);
        const page = ref(1);
        const pageSize = ref(20);
        const total = ref(0);

        const headers = [
            { text: t("Aika").toUpperCase(), value: "timestamp", sortable: false, width: 180 },
            { text: t("Käyttäjä").toUpperCase(), value: "target", sortable: false },
            { text: t("Toiminto").toUpperCase(), value: "action", sortable: false },
            { text: t("Suoritti").toUpperCase(), value: "performed_by", sortable: false },
        ];

        const pageCount = computed(() =>
            pageSize.value > 0 ? Math.ceil(total.value / pageSize.value) : 1
        );

        const actionLabel = (logType) => {
            if (logType === PROMOTE) return t("Pääkäyttäjän oikeudet lisätty");
            if (logType === DEMOTE) return t("Pääkäyttäjän oikeudet poistettu");
            return "";
        };

        const formatTimestamp = (iso) => {
            if (!iso) return "";
            try {
                const d = new Date(iso);
                return d.toLocaleString();
            } catch {
                return iso;
            }
        };

        const fetchLog = async () => {
            loading.value = true;
            const res = await adminApi.getMainUserLog(page.value, pageSize.value);
            if (res.ok) {
                rows.value = res.data.results || [];
                total.value = res.data.count || 0;
            }
            loading.value = false;
        };

        onMounted(fetchLog);
        watch(page, fetchLog);

        return {
            rows,
            loading,
            page,
            pageSize,
            total,
            headers,
            pageCount,
            actionLabel,
            formatTimestamp,
            fetchLog,
            icons: { mdiClose },
        };
    },
};
</script>
